import React, { useContext, useState } from 'react';
import { string, number, func, array } from 'prop-types';
import { translate, Trans } from 'react-i18next';
import classnames from 'classnames/bind';

import ContextStore from '@dragonfruit/services/createContext.js';

import { Button } from '@snapask/common-components';
import TokenDropdown from './components/TokenDropdown';

import { getPriceUnitString } from '@dragonfruit/utils/priceUnit';

import styles from './TokenPack.scss';
const cx = classnames.bind(styles);

function TokenPack({
  name,
  description,
  highlight,
  lowestPlanPrice,
  plans,
  t,
}) {
  const { goToPurchasePage } = useContext(ContextStore);

  const [currentPlan, setCurrentPlan] = useState({
    displayCurrency: '',
    price: lowestPlanPrice,
    paymentMethodId: '',
  });

  const {
    billingCyclePerMonths,
    contractPeriod,
    isContract,
    price,
    currency,
    displayCurrency,
    paymentMethodId,
  } = currentPlan;

  const { displayPrice } = getPriceUnitString({
    billingCyclePerMonths,
    contractPeriod,
    isContract,
    price,
    displayCurrency,
    currency,
  });

  const handleGoToPurchase = () => goToPurchasePage(paymentMethodId);

  return (
    <div className={cx(styles.root, { highlight })}>
      {highlight && <h6 className={styles.label}>{highlight}</h6>}
      <div className={styles.content}>
        <h4 className={styles.price}>
          <Trans i18nKey="premium.priceDisplayFormat">
            Price
            <div className={styles.symbol}>{{ symbol: displayCurrency }}</div>
            <div>{{ number: displayPrice }}</div>
          </Trans>
        </h4>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.description}>{description}</p>
        <TokenDropdown
          className={styles.dropdown}
          value={price}
          options={plans}
          onChangeHandler={setCurrentPlan}
        />
        <Button
          disabled={!paymentMethodId}
          onClick={handleGoToPurchase}
          text={t('premium.tokens.purchaseButtonText')}
        />
      </div>
    </div>
  );
}

TokenPack.propTypes = {
  lowestPlanPrice: number.isRequired,
  name: string.isRequired,
  plans: array.isRequired,
  t: func.isRequired,
  description: string,
  highlight: string,
};

TokenPack.defaultProps = {
  description: null,
  highlight: null,
};

export default translate(['premium'])(TokenPack);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/TokenPack/TokenPack.jsx